import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import cn from 'classnames'

import OrderRow from './OrderRow'
import styles from './List.module.scss'

import { menusAndItemsRequested } from '../../actions/menus'

const OrdersList = ({ onSelectOrder, orders, selectedOrderId, className, fetchMenusAndItems }) => {
  const classNames = cn(styles.ordersList, className)

  useEffect(() => {
    if (localStorage.getItem('accessToken')) fetchMenusAndItems()
  }, [fetchMenusAndItems])

  return (
    <div className={classNames}>
      <div className={styles.headerRow}>
        <div>Order #</div>
        <div>Created</div>
        <div>Synced</div>
        <div>Amount</div>
        <div className={styles.statusCell} />
      </div>
      <div className={styles.scrollable}>
        {orders.map((order) => {
          return (
            <OrderRow
              isSelected={order.uuid === selectedOrderId}
              order={order}
              className={styles.row}
              key={order.uuid}
              onSelect={onSelectOrder}
              refundable={order.refundable}
            />
          )
        })}
      </div>
    </div>
  )
}

OrdersList.defaultProps = {
  orders: [],
}

OrdersList.propTypes = {
  onSelectOrder: PropTypes.func,
  orders: PropTypes.array,
  selectedOrderId: PropTypes.string,
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenusAndItems: () => {
      dispatch(menusAndItemsRequested())
    }
  }
}

export default connect(undefined, mapDispatchToProps)(OrdersList)
